/**
 * Created by chenmf on 2017/6/26.
 */
export const SET_NOTES = 'SET_NOTES'
export const ADD_NOTE = 'ADD_NOTE'
export const DELETE_NOTE = 'DELETE_NOTE'
export const EDIT_NOTE = 'EDIT_NOTE'
export const TOGGLE_FAVORITE = 'TOGGLE_FAVORITE'
export const SET_ACTIVE_NOTE = 'SET_ACTIVE_NOTE'
export const SET_SHOW = 'SET_SHOW'



// WEBPACK FOOTER //
// ./src/store/mutation_types.js